const CONTACT_STORAGE_KEY = {
  SUPPORT_SERVICE_ID: 'contact_support_service_id',
  INFLOW_ROUTE: 'contact_inflow_route',
} as const;

export const CONTACT_INFLOW_ROUTE = {
  SUPPORT_SERVICE: 1,
  FOOTER: 2,
  ERROR_PAGE: 3,
  DIRECT_ACCESS: 4,
  COMPANY_EDIT: 5,
  USER_REGISTRATION: 6,
} as const;

export default CONTACT_STORAGE_KEY;
